import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_systemDefaultFixedWidthFont14cv3wy0prdkq as get_systemDefaultFixedWidthFont,
  get_rem14pbkv8p42gid as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Fixed1p8lc8swyflir as Fixed } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CodeBlockSemanticClass;
function CodeBlockSemantic() {
  if (CodeBlockSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        CodeBlockSemantic_instance = null;
        super('mdc');
        CodeBlockSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_font = theme.font_1.copy$default_cfilcw_k$(get_systemDefaultFixedWidthFont());
        var tmp1_background = theme.background_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(-0.1);
        var tmp2_cornerRadii = new (Fixed())(get_rem(0.25));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp0_font, VOID, tmp2_cornerRadii, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'CodeBlockSemantic';
      }
      hashCode() {
        return 598867447;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CodeBlockSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CodeBlockSemantic');
    CodeBlockSemanticClass = $;
  }
  return CodeBlockSemanticClass;
}
var CodeBlockSemantic_instance;
function CodeBlockSemantic_getInstance() {
  if (CodeBlockSemantic_instance === VOID)
    new (CodeBlockSemantic())();
  return CodeBlockSemantic_instance;
}
//region block: exports
export {
  CodeBlockSemantic_getInstance as CodeBlockSemantic_getInstance2upnqm8klgt9a,
};
//endregion

//# sourceMappingURL=TempSemantics.mjs.map
